export const recommendProducts = [
    {
        itemId: '1',
        itemTitle: 'Mens Natural Run Short',
        variantTitle: 'blue',
        originPrice: 3800,
        discountedPrice: 4600,
        imgUrl: 'https://cdn.shopify.com/s/files/1/1104/4168/products/210525_Allbirds_PDP_03_Tee-Oceanus_Short-Shadow_Mens_0725.jpg',
        quantity: 1,
        imgAlt: 'alt',
        productUrl: 'https://www.google.com/'
    },
    {
        itemId: '2',
        itemTitle: 'Mens Trail Runners SWT',
        variantTitle: 'blue',
        originPrice: 1100,
        discountedPrice: null,
        imgUrl: 'https://cdn.shopify.com/s/files/1/1104/4168/products/TD1MKIL080_SHOE_LEFT_GLOBAL_MENS_TREE_DASHER_KILIMANJARO_WHITE_1ea60d52-b2a5-440a-9cde-be97acecbc4c.png?v=1626285739',
        quantity: 1,
        imgAlt: 'alt',
        productUrl: 'https://www.google.com/'
    },
    {
        itemId: '3',
        itemTitle: 'Mens Long Sleeve Sea Tee',
        variantTitle: 'blue',
        originPrice: 1234,
        discountedPrice: 4521,
        imgUrl: 'https://cdn.shopify.com/s/files/1/1104/4168/products/XXXXXX080_SHOE_PAIR_GLOBAL_MENS_WOOL_PIPER_MID_SIERRA_WHITE_d7bd5db9-2bf5-4cf7-95b5-fea8bf3be826.png?v=1631922968',
        quantity: 1,
        imgAlt: 'alt',
        productUrl: 'https://www.google.com/'
    },
    {
        itemId: '4',
        itemTitle: 'ograne',
        variantTitle: 'blue',
        originPrice: 3214,
        discountedPrice: 4521,
        imgUrl: 'https://casper.imgix.net/original-pillow.jpg?auto=compress,format&q=65&w=256',
        quantity: 1,
        imgAlt: 'alt',
        productUrl: 'https://www.google.com/'
    }
];
export default recommendProducts;
export const myRewards = [
    {
        id: 0,
        name: 'Economy Shipping',
        targetValue: 8000,
        unlocked: false
    },
    {
        id: 1,
        name: 'Free Shipping',
        targetValue: 10000,
        unlocked: false
    },
    {
        id: 2,
        name: '5% Off',
        targetValue: 15000,
        unlocked: false
    },
    {
        id: 3,
        name: '10% Off',
        targetValue: 30000,
        unlocked: false
    }
];
